import { css } from "@emotion/react";

export const pageContainer = css`
  @media all and (max-width: 1200px) {
    padding-right: 11.33%;
    padding-left: 11.33%;
  }
  @media all and (max-width: 900px) {
    padding-right: 4.55%;
    padding-left: 4.55%;
  }
  @media all and (max-width: 600px) {
    padding-right: 4.16%;
    padding-left: 4.16%;
  }
  @media all and (max-width: 480px) {
    padding-right: 6.66%;
    padding-left: 6.66%;
  }
`;